import QueryManager from "../../../utils/QueryManager";
import {getLocalStorageKey} from "../../../settings";
import dayjs from "dayjs";

const curLocalStorageKey = getLocalStorageKey("agent_filters");

let agentFiltersSerializableDates:string[] = [

]

let agentFiltersSerializableJoins:string[] = [

]

class AgentFiltersManagerClass extends QueryManager {
}

const AgentFiltersManager = new AgentFiltersManagerClass({
    serializable: {dates: agentFiltersSerializableDates, joins: agentFiltersSerializableJoins},
    localStorageKey: curLocalStorageKey
});

export default AgentFiltersManager;